const calculateNumberOfNights = (startDate, endDate) => {
  const numberOfNightsInMs = endDate - startDate;
  return Math.ceil(numberOfNightsInMs / (1000 * 3600 * 24));
};

const dateAndTimeFromISO = (timeISO) => {
  if (timeISO) {
    // 'T' with space, remove seconds and milliseconds
    return timeISO.replace("T", " ").slice(0, -8);
  } else return null;
};

export { calculateNumberOfNights, dateAndTimeFromISO };
